export const fontFamily = [
  "Inter",
  "David Libre",
  "Andika New Basic",
  "Roboto",
  "Prompt",
  "Sarabun",
  "Chakra Petch",
];
